
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

export function insertFollows (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/market/follow',
    method: 'POST',
    data: parameter
  })
}
export function updateFollows (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/market/follow',
    method: 'POST',
    data: parameter
  })
}
export function deleteFollows (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/market/follow?ids=' + parameter,
    method: 'DELETE'
  })
}
export function getFollowsList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/market/follows',
    method: 'GET',
    params: parameter
  })
}
export function getFollowsInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/follows',
    method: 'GET',
    params: parameter
  })
}
